import MagicWand from 'magic-wand-tool';

/**
 * Usa a varinha mágica para selecionar áreas similares na imagem
 *
 * @param {HTMLCanvasElement} canvas - Canvas com a imagem
 * @param {ImageData} mask - Máscara atual
 * @param {number} x - Coordenada X do clique
 * @param {number} y - Coordenada Y do clique
 * @param {number} tolerance - Tolerância (0-100)
 * @param {string} mode - Modo: 'add' (adiciona área) ou 'remove' (remove área)
 * @returns {Object} { mask: ImageData, selection: Object } Nova máscara e dados da seleção
 */
export function applyMagicWand(canvas, mask, x, y, tolerance, mode = 'remove') {
  const ctx = canvas.getContext('2d');
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

  // Converte tolerância de 0-100 para 0-255
  const normalizedTolerance = Math.floor((tolerance / 100) * 255);

  // Usa a varinha mágica para obter a seleção
  const image = {
    data: imageData.data,
    width: canvas.width,
    height: canvas.height,
    bytes: 4 // RGBA
  };

  // Calcula a máscara da varinha mágica
  const wandMask = MagicWand.floodFill(image, x, y, normalizedTolerance);

  if (!wandMask) {
    console.warn('Magic wand selection failed');
    return { mask, selection: null };
  }

  // Cria nova máscara combinando a máscara atual com a seleção da varinha
  const newMask = ctx.createImageData(canvas.width, canvas.height);
  newMask.data.set(mask.data);

  // Aplica a seleção baseado no modo
  for (let i = 0; i < wandMask.data.length; i++) {
    if (wandMask.data[i] === 1) { // Pixel selecionado
      const pixelIndex = i * 4;

      if (mode === 'remove') {
        // Remove a área (pinta de preto)
        newMask.data[pixelIndex] = 0;     // R
        newMask.data[pixelIndex + 1] = 0; // G
        newMask.data[pixelIndex + 2] = 0; // B
        newMask.data[pixelIndex + 3] = 255; // A
      } else if (mode === 'add') {
        // Adiciona a área (pinta de branco)
        newMask.data[pixelIndex] = 255;     // R
        newMask.data[pixelIndex + 1] = 255; // G
        newMask.data[pixelIndex + 2] = 255; // B
        newMask.data[pixelIndex + 3] = 255; // A
      }
    }
  }

  return {
    mask: newMask,
    selection: wandMask
  };
}

/**
 * Expande a seleção da varinha mágica
 *
 * @param {Object} wandMask - Máscara retornada pela varinha mágica
 * @param {number} radius - Raio de expansão em pixels
 * @returns {Object} Máscara expandida
 */
export function expandMagicWandSelection(wandMask, radius = 2) {
  if (!wandMask || radius <= 0) return wandMask;

  return MagicWand.gaussBlurOnlyBorder(wandMask, radius);
}
